import { InvestmentCalendarView } from '@/components/InvestmentCalendarView';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';

export default function InvestmentCalendarPage() {
  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <InvestmentCalendarView />
    </>
  );
}
